import { Outlet, createFileRoute, redirect } from '@tanstack/react-router'
import { AppLayout } from '@/components/AppLayout'
import { isAuthenticated } from '@/lib/auth-store'

export const Route = createFileRoute('/collection-pages')({
  beforeLoad: () => {
    if (!isAuthenticated()) {
      throw redirect({ to: '/login' })
    }
  },
  component: CollectionPagesLayout,
})

function CollectionPagesLayout() {
  return (
    <AppLayout title="Collection Pages">
      <Outlet />
    </AppLayout>
  )
}
